import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'
import * as SolidIcons from '@fortawesome/free-solid-svg-icons'
import * as RegularIcons from '@fortawesome/free-regular-svg-icons'
import * as BrandsIcons from '@fortawesome/free-brands-svg-icons'

Vue.component('fa-icon', FontAwesomeIcon)
Vue.component('fa-layers', FontAwesomeLayers)

library.add(
  // Solid icons
  SolidIcons.faArchive,
  SolidIcons.faSearch,
  SolidIcons.faMagic,
  SolidIcons.faEyeSlash,
  SolidIcons.faCloudDownloadAlt,
  SolidIcons.faAngleDown,
  SolidIcons.faArrowLeft,
  SolidIcons.faArrowRight,
  SolidIcons.faTimesCircle,
  SolidIcons.faCheck,
  SolidIcons.faEye,
  SolidIcons.faPencilAlt,
  SolidIcons.faTimes,
  SolidIcons.faSearchPlus,
  SolidIcons.faChevronLeft,
  SolidIcons.faChevronRight,
  SolidIcons.faUser,
  SolidIcons.faSave,
  SolidIcons.faTrashRestoreAlt,
  SolidIcons.faTools,
  SolidIcons.faBookOpen,
  SolidIcons.faGlobeAmericas,
  SolidIcons.faNewspaper,
  SolidIcons.faPlus,
  SolidIcons.faMinus,
  SolidIcons.faExclamation,
  SolidIcons.faAngleDoubleRight,
  SolidIcons.faFileImport,
  SolidIcons.faHourglassHalf,
  SolidIcons.faExclamationTriangle,
  SolidIcons.faHighlighter,
  SolidIcons.faThumbtack,
  SolidIcons.faAsterisk,
  SolidIcons.faCheckSquare,
  SolidIcons.faExternalLinkAlt,
  SolidIcons.faShareAlt,
  SolidIcons.faQuestionCircle,
  SolidIcons.faAngleDoubleDown,
  SolidIcons.faThLarge,
  SolidIcons.faClock,
  SolidIcons.faGlobeEurope,
  SolidIcons.faArrowUp,
  SolidIcons.faArrowDown,
  SolidIcons.faStar,
  SolidIcons.faUpload,
  SolidIcons.faRedo,
  SolidIcons.faPrint,
  SolidIcons.faArrowsAltH,
  SolidIcons.faEnvelope,
  SolidIcons.faFont,
  SolidIcons.faInfoCircle,

  // Regular icons
  RegularIcons.faNewspaper,
  RegularIcons.faPlusSquare,
  RegularIcons.faTrashAlt,
  RegularIcons.faEnvelope,
  RegularIcons.faCalendarAlt,
  RegularIcons.faSquare,
  RegularIcons.faLifeRing,
  RegularIcons.faClock,
  RegularIcons.faCheckCircle,

  // Brands icons
  BrandsIcons.faInstagram
)
